import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
import FastTabs, { TabsDatas } from '../../../components/tabs/tabs';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/constants';
import { TableRequestPoint } from '../../../redux/reducers/table';
import { FormatType, HeadCell } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';

// Values of the core "driver.issue" filter, which also restricts the listing to the active drivers
type DriverIssue = 'default_prebook_group' | 'no_control_tower' | 'no_driving_licence';

const ISSUES: { issue: DriverIssue; type: TableRequestPoint }[] = [
    { issue: 'default_prebook_group', type: tableRequestPoints.DRIVERS_ISSUE_DEFAULT_PREBOOK_GROUP },
    { issue: 'no_control_tower', type: tableRequestPoints.DRIVERS_ISSUE_NO_CONTROL_TOWER },
    { issue: 'no_driving_licence', type: tableRequestPoints.DRIVERS_ISSUE_NO_DRIVING_LICENCE },
];

interface DriversIssuesPageProps extends WithTranslation {}

const DriversIssuesPage = ({ t }: DriversIssuesPageProps): JSX.Element => {
    const headerBuilder = (): HeadCell[] => [
        createCell(t, Cell.ID, { sortable: true }),
        { id: 'fullname', label: t('common:form.firstname') },
        createCell(t, Cell.EMAIL),
        createCell(t, Cell.PHONE_NUMBER),
        { id: 'partner.name', label: t('common:form.partner') },
        { id: 'details.controlTower.name', label: t('control_tower') },
        { id: 'details.prebookGroup.name', label: t('prebook_group') },
        {
            id: 'details.activationDate',
            label: t('issues.columns.activation_date'),
            type: FormatType.DateShort,
            filterable: false,
        },
        {
            id: 'details.prebookGroupEntryDate',
            label: t('issues.columns.prebook_group_entry_date'),
            type: FormatType.DateShort,
            filterable: false,
            sortable: true,
        },
    ];

    const tabs: TabsDatas = {
        storageKey: 'drivers-issues-tab',
        datas: ISSUES.map(({ issue, type }) => ({
            label: t(`issues.tabs.${issue}`),
            children: (
                <EnhancedTable
                    headers={headerBuilder()}
                    type={type}
                    filterParams={{ 'filters[driver.issue]': issue }}
                />
            ),
        })),
    };

    return (
        <App
            header={{
                title: t('issues.title'),
                subtitle: t('issues.description'),
            }}
        >
            <FastTabs tabs={tabs} />
        </App>
    );
};

export default withTranslation(['driver', 'common'])(DriversIssuesPage);
